import React from 'react';
import { NavLink } from 'react-router-dom';
import { NavLinkProps } from 'react-router-dom';
import { useNavigateSafe } from 'apps/sigma2-ui/src/lib/hooks/useNavigateSafe';
import { uiAppLogger } from 'apps/sigma2-ui/src/lib/logging';

// This component ensures that your link scrolls to the hash on the page, even if the hash doesn't change.
// For example, if you click a link and that changes the hash to #foo, then click the same link again, the hash won't change.
// Even if it does not change, we want the page to scroll to the #foo element.
// If you are looking at this code, you may find the `useEffect` in `MainLayout.tsx` interesting, since it handles
// scrolling to the hash on page load as well as when the React Router changes the hash from an arbitrary source.

export const RoutableLink = React.forwardRef<HTMLAnchorElement, NavLinkProps>(
  (props, ref) => {
    const navigate = useNavigateSafe();

    return (
      <NavLink
        {...props}
        ref={ref}
        onClick={(e) => {
          uiAppLogger.info('clicking a nav link');
          if (props.onClick) {
            props.onClick(e);
          }

          if (e.defaultPrevented) {
            return;
          }

          uiAppLogger.info('passed handler');

          const hash = props.to?.toString().split('#')[1];

          if (props.to?.toString().startsWith('mailto:')) {
            return;
          }

          e.preventDefault();

          if (hash) {
            const element = document.getElementById(hash);
            if (element) {
              element.scrollIntoView({ behavior: 'smooth' });
              return;
            }
          }

          navigate(props.to?.toString());
        }}
      />
    );
  },
);

RoutableLink.displayName = 'RoutableLink';
